import axios from 'axios';

// Use relative URLs when REACT_APP_API_URL is empty (same domain deployment)
// Otherwise use the provided API URL (for separate backend deployment)
const getBaseURL = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  // Handle empty string, undefined, null, or literal "" (with quotes)
  if (!apiUrl || apiUrl === '' || apiUrl === '""' || apiUrl.trim() === '') {
    // Empty string = same domain (Vercel serverless deployment)
    return '';
  }
  return apiUrl;
};

const instance = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000, // 10 second timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    console.log('Making request to:', config.url);
    console.log('Full URL:', `${config.baseURL}${config.url}`);
    console.log('Request method:', config.method);
    console.log('Request headers:', config.headers);
    console.log('Request data:', config.data);
    
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn('No token found in localStorage');
    }
    return config;
  },
  (error) => {
    console.error('Request error:', {
      message: error.message,
      config: error.config,
      stack: error.stack
    });
    return Promise.reject(error);
  }
);

// Response interceptor
instance.interceptors.response.use(
  (response) => {
    console.log('Response received:', {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('Response error:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message,
      config: error.config,
      stack: error.stack
    });

    // Handle network errors
    if (!error.response) {
      console.error('Network error - no response received');
      return Promise.reject({
        message: 'Network error - please check if the server is running',
        originalError: error
      });
    }

    // Don't handle 401 errors here to avoid infinite loops
    // Let individual components handle 401 errors as needed

    return Promise.reject(error);
  }
);

export default instance; 
